import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import Loader from '../../../views/admin/Common/Loader';
import { getGamePricing, getSetting, updatePricing, updatSetting } from '../../../API/admin'
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import Swal from 'sweetalert2';
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormInput
} from '@coreui/react'

const Config = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Site Settings', to: '/config', active: true }
    ];

    const [games, setGames] = useState([]);
    const Navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [visible, setVisible] = useState(false);
    const [selectedGame, setSelectedGame] = useState({ id: '', name: '', price: '' });
    const [loaderStatus, setloaderStatus] = useState(false);
    const [isOn, setIsOn] = useState(false);
    const [isOnTournament, setIsOTournamentn] = useState(false);
    const [isInputValid, setIsInputValid] = useState(true);
    const [adminEmail, setAdminEmail] = useState(null);
    const [editEmail, setEditEmail] = useState(true);




    let GetPricingAPI = async () => {
        setloaderStatus(true)
        let res = await getGamePricing()
        setloaderStatus(false)

        console.log(res)
        if (res.status) {
            setGames(res.data);


        } else {
            setGames([]);
            enqueueSnackbar('unable to get price', {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });

        }
    }

    let GetSettingAPI = async () => {
        setloaderStatus(true)
        let res = await getSetting()
        setloaderStatus(false)

        if (res.status) {
            res.data.map((entry, map) => {
                if (entry.name === 'withdrawal') {
                    setIsOn(entry.value);
                }

                if (entry.name === 'tournament_register') {
                    setIsOTournamentn(entry.value)
                }
                if (entry.name === 'admin_email') {
                    setAdminEmail(entry.value)
                }
            })


        } else {
            setIsOn(null);
            setIsOTournamentn(null)
            enqueueSnackbar('unable to fetch setting', {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });

        }
    }
    let HandelUpdate = async (id, price) => {
        let formData = {
            "id": id,
            "price": price
        }
        setloaderStatus(true)

        let res = await updatePricing(formData)

        if (res.status) {
            setloaderStatus(false)
            enqueueSnackbar('Data updated successfully', {
                variant: 'success', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });

            window.location.reload()
        } else {
            setloaderStatus(false)
            enqueueSnackbar('Unable to update data', {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });

        }
    }

    const handleEditClick = (game) => {
        setSelectedGame(game);
        setVisible(true);
    };


    const handleInputChange = (e) => {
        const isChecked = e.target.checked;
        var actionText;
        var confirmationText;
        if (e.target.name === 'Withdrawal') {
            setIsOn(isChecked);
            actionText = isChecked
                ? "allow participants withdrawal from the game"
                : "stop participants withdrawal from the game";
            confirmationText = isChecked
                ? "Participants will be able to withdraw from the game."
                : "Participants will no longer be able to withdraw from the game.";

        }
        else if (e.target.name === 'tournament_register') {
            setIsOTournamentn(isChecked);
            actionText = isChecked
                ? "Open registration for tournament"
                : "Close registration for tournament";
            confirmationText = isChecked
                ? "Participants will be able to Register in tournament"
                : "Participants will no longer be able to Register in tournament";


        } else {
            if (/\s/.test(adminEmail)) {
                // If the input includes spaces, show a warning message
                Swal.fire({
                    title: `Invalid email`,
                    text: 'Please enter a valid email',
                    icon: "error",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "OK"
                })
                return 0;
            }
            actionText = 'change admin email';
            confirmationText = 'You will receive all the admin mails to the provided email. ';
        }
        Swal.fire({
            title: `Are you sure you want to ${actionText}?`,
            text: confirmationText,
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "Close"

        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    var formData;
                    if (e.target.name === 'Withdrawal') {
                        formData = {
                            name: "withdrawal",
                            value: isChecked  // Use captured value here
                        };

                    }
                    if (e.target.name === 'tournament_register') {
                        formData = {
                            name: "tournament_register",
                            value: isChecked  // Use captured value here
                        };
                    }
                    if (e.target.name === 'admin_email') {
                        formData = {
                            name: "admin_email",
                            value: adminEmail  // Use captured value here
                        };
                    }

                    setloaderStatus(true);
                    let res = await updatSetting(formData);

                    if (res.data.status) {
                        enqueueSnackbar('Setting is updated', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        });
                        if (res.data.data.name === 'Withdrawal') {

                            setIsOn(res.data.data.value);
                        }
                        if (res.data.data.name === 'tournament_register') {
                            setIsOTournamentn(res.data.data.value);
                        }
                        if (res.data.data.name === 'admin_email') {
                            setEditEmail(true);
                        }

                    } else {
                        enqueueSnackbar('Unable to update setting', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        });
                    }
                } catch (error) {
                    console.error('Error updating setting:', error);
                    enqueueSnackbar('An error occurred while updating the setting', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                } finally {
                    setloaderStatus(false);
                }
            } else {
                if (e.target.name === 'Withdrawal') {
                    setIsOn(!isChecked);
                }
                if (e.target.name === 'tournament_register') {
                    setIsOTournamentn(!isChecked)
                }
            }
        });

        console.log('Switch toggled:', isChecked);
    };

    const handlePriceChange = (e) => {
        const { name, value } = e.target;
        setSelectedGame((prevGame) => ({
            ...prevGame,
            [name]: value
        }));
    }
    const handleEmailChange = (e) => {
        setAdminEmail(e.target.value);
    }
    const updateAdminEmail = () => {

    }
    const handleSaveChanges = () => {
        // Call your update function with id and updated price
        console.log(selectedGame);

        HandelUpdate(selectedGame.id, selectedGame.price);
        setVisible(false);
    };

    useEffect(() => {
        GetPricingAPI()
        GetSettingAPI()
    }, [])

    return (
        <>
            {loaderStatus ?
                <Loader />
                : null}
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            {/* registration settings */}
            <CCard className='mb-5'>
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h4 className="card-title mb-3">
                                Tournament Registration
                            </h4>

                        </CCol>
                        <CCol xl={8}>
                            <div className="form-check form-switch ms-3 float-end">
                                <input
                                    className="form-check-input text-white"
                                    type="checkbox"
                                    role="switch"
                                    name='tournament_register'
                                    id="flexSwitchCheckDefault"
                                    checked={isOnTournament === "true" ? true : false}
                                    value={isOnTournament === "true" ? true : false}
                                    onChange={handleInputChange}
                                    style={{ height: '30px', width: '60px' }} // Custom size
                                />

                            </div>
                        </CCol>
                    </CRow>


                </CCardBody>
            </CCard>
            {/* withdarwal setting */}
            <CCard className='mb-5'>
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h4 className="card-title mb-3">
                                Withdrawal Setting
                            </h4>

                        </CCol>
                        <CCol xl={8}>
                            <div className="form-check form-switch ms-3 float-end">
                                <input
                                    className="form-check-input text-white"
                                    type="checkbox"
                                    role="switch"
                                    name='Withdrawal'
                                    id="flexSwitchCheckDefault"
                                    checked={isOn === "true" ? true : false}
                                    value={isOn === "true" ? true : false}
                                    onChange={handleInputChange}
                                    style={{ height: '30px', width: '60px' }} // Custom size
                                />

                            </div>
                        </CCol>
                    </CRow>


                </CCardBody>
            </CCard>

            <CCard className='mb-5'>
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h4 className="card-title mb-3">
                                Admin Mail
                            </h4>
                            <input
                                className="border-3     form-control "
                                type="text"
                                name='admin_email'
                                readOnly={editEmail}
                                value={adminEmail}
                                required
                                pattern="^\S+$"
                                onChange={handleEmailChange}
                            />

                        </CCol>
                        <CCol xl={8}>
                            {
                                editEmail ? (

                                    <CButton title='Edit' onClick={() => setEditEmail(false)} className='bi bi-pencil text-white float-end' color="warning"></CButton>
                                ) :
                                    <div className='d-flex justify-content-center float-end'>

                                        <CButton title='close' onClick={() => setEditEmail(true)} className='bi bi-x-circle text-white float-end' color="danger"></CButton>
                                        <CButton title='Save' name='admin_email' onClick={(e) => handleInputChange(e)} className='bi bi-floppy text-white float-end' color="primary"></CButton>
                                    </div>
                            }

                        </CCol>
                    </CRow>


                </CCardBody>
            </CCard>
            {/* games settings */}
            <CCard>
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h4 className="card-title mb-3">
                                Games Pricing
                            </h4>
                        </CCol>
                    </CRow>
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center"
                    >
                        <CTable striped>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Price</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    games.length > 0 ? (

                                        games.map((Game, index) => (
                                            <CTableRow>

                                                <CTableDataCell>{index + 1}</CTableDataCell>
                                                <CTableDataCell>{Game.name === 'badminton' ? 'Badminton' : Game.name === 'table_tenis' ? "Table Tenis" : Game.name === 'bowling' ? 'Bowling' : Game.name === '2k_run' ? '2k Run' : 'N/A'}</CTableDataCell>
                                                <CTableDataCell > ${Game.price}</CTableDataCell>
                                                <CTableDataCell>
                                                    <CButton onClick={() => handleEditClick(Game)} title='Edit' className='bi bi-pencil text-white' color="warning"></CButton>

                                                </CTableDataCell>

                                            </CTableRow>

                                        ))

                                    ) : (
                                        <CTableRow>
                                            <CTableDataCell colSpan={3}> No data found</CTableDataCell>
                                        </CTableRow>
                                    )
                                }

                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>

            <CModal
                alignment="center"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="VerticallyCenteredExample"
            >
                <CModalHeader>
                    <CModalTitle id="VerticallyCenteredExample">Edit Game Pricing</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <CFormInput
                        label="Game Name"
                        value={selectedGame.name === 'badminton' ? 'Badminton' :
                            selectedGame.name === 'table_tenis' ? "Table Tennis" :
                                selectedGame.name === 'bowling' ? 'Bowling' :
                                    selectedGame.name === '2k_run' ? '2k Run' : 'N/A'}
                        readOnly
                        className="mb-3"
                    />
                    <CFormInput
                        label="Price"
                        name="price"
                        type="number"
                        min={1}
                        value={selectedGame.price}
                        onChange={handlePriceChange}
                        className="mb-3"
                        title="invalid Value"
                        onInput={(e) => {
                            const value = parseFloat(e.target.value); // Use parseFloat to allow detection of decimal values
                            if (value < 1 || !Number.isInteger(value)) {
                                // Check if value is less than 1 or not an integer
                                e.target.setCustomValidity("Please enter a whole number greater than 1");
                                setIsInputValid(false); // Disable submit button if invalid
                            } else {
                                e.target.setCustomValidity("");
                                setIsInputValid(true); // Enable submit button if valid
                            }
                            e.target.reportValidity(); // Ensure the error is shown
                        }}
                    />
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setVisible(false)}>
                        Close
                    </CButton>

                    <CButton color="primary" onClick={handleSaveChanges} disabled={!isInputValid}>
                        Save changes
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default Config;